export default __webpack_public_path__ + "static/media/shivam-bhai-profile.61ee0654.jpeg";